module.exports = __webpack_public_path__ + "img/com.kelvinator.airconditioner.882f169b.webp";